import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEDivider, FHEItemText } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';

class SDM18HCL extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        threshold: PropTypes.number,
        remoteBrand: PropTypes.string,
        remoteRef: PropTypes.string,
        lineType: PropTypes.string,
        operatingMode: PropTypes.string,
        climState: PropTypes.string,
        climStatus: PropTypes.string
    };

    static defaultProps = {
        threshold: null,
        remoteBrand: null,
        remoteRef: null,
        lineType: null,
        operatingMode: null,
        climState: null,
        climStatus: null
    };

    render() {
        const { threshold, remoteBrand, remoteRef, lineType, operatingMode, climState, climStatus, theme, history } = this.props;
        return (
            <FHEContainerForm>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.operatingMode')}
                            itemContent={Translator.translate(`general.productModules.${operatingMode}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.threshold')} itemContent={threshold} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.remoteBrand')} itemContent={remoteBrand} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.remoteRef')} itemContent={remoteRef} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.lineType')}
                            itemContent={Translator.translate(`general.productModules.${lineType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.climState')} itemContent={climState} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.climStatus')} itemContent={climStatus} />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    let productModule;
    if (state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map()).first();
    }
    if (productModule === undefined) {
        productModule = new Map();
    }
    return {
        threshold: productModule.get('threshold'),
        remoteBrand: productModule.get('remoteBrand'),
        remoteRef: productModule.get('remoteRef'),
        lineType: productModule.get('lineType'),
        operatingMode: productModule.get('operatingMode'),
        climState: productModule.get('climState'),
        climStatus: productModule.get('climStatus')
    };
}

export default withRouter(renderEnvComponent('scenes/Products/components/Product/Fhe/SDM18HCL/index', connect(mapStateToProps)(withTheme(SDM18HCL))));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM18HCL/index.js